import { useState } from 'react';
import clsx from 'clsx';
import { useProfileStore } from '../store/profileStore';

const CLOSE_DURATION_MS = 300;

export const useModalAnimation = (onClose: () => void) => {
  const { isModalAnimationEnabled } = useProfileStore(state => state);
  const isEnabled = isModalAnimationEnabled;
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    if (!isEnabled) {
      onClose();
      return;
    }
    setIsClosing(true);
    setTimeout(() => {
      onClose();
      setIsClosing(false);
    }, CLOSE_DURATION_MS);
  };

  const animationClassName = isEnabled ? clsx(isClosing ? 'modal-close-animation' : 'modal-open-animation') : undefined;

  return { handleClose, animationClassName };
};
